// extracted by mini-css-extract-plugin
export default {"main":"FormLifeYearsInput_main__+ZJlY","label":"FormLifeYearsInput_label__94Dim","row":"FormLifeYearsInput_row__AUZU6"};